module.exports = __webpack_public_path__ + "static/media/switch.c0f7e6a1.svg";